module.exports = __webpack_public_path__ + "static/media/windows-icon.69eac421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/windows-icon.png
// module id = 955
// module chunks = 1